import { useTranslation } from 'react-i18next'

import ConditionsEditor from '@/common/components/ConditionsEditor/ConditionsEditor'

import { errorTypes } from './constants'
import { getConditionTypes } from './helpers'

const EmailTemplateConditionsEditor = ({
  conditions,
  errors,
  onChange,
  disabled,
  productTypes,
  productCategories,
  productCollections,
  regions,
  locations,
  carriers,
  carrierServices,
  returnReasons,
  currencies,
  storeCurrencyCode,
  disabledConditionFields = [],
}) => {
  const { t, i18n } = useTranslation()

  const conditionTypes = getConditionTypes({
    productTypes,
    productCategories,
    productCollections,
    locations,
    carriers,
    carrierServices,
    returnReasons,
    regions,
    language: i18n.language,
    disabledConditionFields,
    t,
  })

  return (
    <ConditionsEditor
      conditions={conditions}
      onChange={onChange}
      disabled={disabled}
      title="Condiciones"
      description="Define las condiciones que deben cumplirse para que este email se envíe."
      conditionTypes={conditionTypes}
      errors={errors}
      errorType={errorTypes.conditionIncomplete}
      currencies={currencies}
      storeCurrencyCode={storeCurrencyCode}
    />
  )
}

export default EmailTemplateConditionsEditor
